/**
 * Swiper 11.0.6
 * @url : https://swiperjs.com/api/
 */
// import Swiper JS
// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Keyboard, Pagination, A11y, EffectFade } from 'swiper/modules';

// Load Swiper with Drupal BigPipe Support
(function ($, Drupal) {
  Drupal.behaviors.LoadSwiper = {
    attach: function (context, settings) {
      /**
       * Swiper articles
       */
      const SwipersArticles = context.querySelectorAll('.js-swiper-articles');
      if (SwipersArticles.length) {
        for (const swiper of SwipersArticles) {
          // Swiper instance
          const swiperInstance = new Swiper(swiper.querySelector('.swiper'), {
            modules: [Navigation, Keyboard, EffectFade, A11y, Pagination],
            slidesPerView: 1,
            speed: 700,
            navigation: {
              nextEl: swiper.querySelector('.swiper-button-next'),
              prevEl: swiper.querySelector('.swiper-button-prev'),
            },
            pagination: {
              el: swiper.querySelector('.swiper-pagination'),
              clickable: false,
            },
            effect: 'fade',
            keyboard: true,
            init: false,
          });

          // Fix issue https://github.com/nolimits4web/swiper/issues/2915
          swiperInstance.on('slideChange', function() {
            swiperInstance.pagination.render();
            swiperInstance.pagination.update();
          });

          // Init only if there is 2 or more slides
          const nbSlides = swiper.querySelectorAll('.swiper-slide');

          if (nbSlides.length > 1) swiperInstance.init();
        }
      }
    },
  };
})(jQuery, Drupal);
